import constants from '../../../../ahm-constants';

const staticFrequency = constants.PAYMENT_FREQUENCY.YEARLY;
const scale = constants.SCALE.SINGLE;

const marks = {
  18: '18',
  25: '25',
  26: '26',
  27: '27',
  28: '28',
  29: '29',
  30: '30+',
};

const percentages = {
  18: 0.1,
  19: 0.1,
  20: 0.1,
  21: 0.1,
  22: 0.1,
  23: 0.1,
  24: 0.1,
  25: 0.1,
  26: 0.08,
  27: 0.06,
  28: 0.04,
  29: 0.02,
  30: 0,
} as Record<number, number>;

const productId = constants.PRODUCT.BRONZE_PLUS_EVERYDAY_EXCESS_750;

export { staticFrequency, productId, marks, percentages, scale };
